import { PropsCreatePost } from 'src/components/InputMarkdown/types'
import useMutation from 'src/hook/useMutation'
import { PostsService } from 'src/services/posts'

const usePostCreatePublication = () =>
  useMutation((publication: PropsCreatePost) => PostsService.createPublication(publication))

export default usePostCreatePublication
